// Runtime practice/department resolution — replaces build-time
// REACT_APP_PRACTICE_ID so one build serves every practice.
//
// Resolution order for the practice id:
//   1. localStorage['practiceid']  (set by the login screen)
//   2. the `practice_id` claim of the JWT in localStorage['auth']
//      (covers the ?allowtoken= SSO flow with no extra UI)
//   3. null
//
// Exposed as window.getPracticeId / window.getDepartmentId in index.js so the
// 200+ mechanical call sites need no import.

function decodeJwtClaim(token, claim) {
  try {
    const payload = token.split(".")[1];
    const json = JSON.parse(atob(payload.replace(/-/g, "+").replace(/_/g, "/")));
    return json[claim] ?? null;
  } catch (e) {
    return null;
  }
}

export function getPracticeId() {
  const stored = localStorage.getItem("practiceid");
  if (stored) return stored;
  const token = localStorage.getItem("auth");
  if (token) {
    const claim = decodeJwtClaim(token, "practice_id");
    if (claim != null) return String(claim);
  }
  return null;
}

export function getDepartmentId() {
  return localStorage.getItem("departmentid") || "1";
}

export function setPracticeSession(practiceId, departmentId) {
  localStorage.setItem("practiceid", String(practiceId));
  if (departmentId != null) {
    localStorage.setItem("departmentid", String(departmentId));
  }
}

export function clearPracticeSession() {
  localStorage.removeItem("practiceid");
  localStorage.removeItem("departmentid");
}

// Load-time side effect: expose the runtime-tenancy globals IMMEDIATELY when this
// module evaluates. index.js imports this module FIRST, so every later module's
// top-level `window.getPracticeId()` capture (e.g. CareIQTab.jsx) finds the
// function defined. Assigning from index.js's body is too late — ES imports are
// hoisted and evaluate before any of index.js's own statements run.
window.getPracticeId = getPracticeId;
window.getDepartmentId = getDepartmentId;
window.clearPracticeSession = clearPracticeSession;
